import React, { useState } from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import { notBlank } from "../util/ext";
import { useSubscriptions } from "./subscriptionService";
import SubscriptionsBrowse from "./SubscriptionsBrowse";
import { useLocation } from "react-router-dom";

const ManageSubscriptionsView = () => {
  const { state = {} } = useLocation();
  const initialSearchState = {
    appliedOrganization: state.organizationId,
    appliedModule: state.module,
    orderBy: null,
    orderDirection: "asc",
    activeOnly: true,
    perpetualOnly: false,
    includeIndirect: false,
    appliedTypes: null,
    expiresBefore: null,
    page: 0,
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useSubscriptions(
    searchState.appliedOrganization,
    searchState.appliedModule,
    searchState.includeIndirect,
    searchState.activeOnly,
    searchState.perpetualOnly,
    searchState.appliedTypes,
    searchState.expiresBefore,
    notBlank(searchState.orderBy)
      ? `${searchState.orderBy} ${searchState.orderDirection}`
      : null,
    searchState.page,
  );

  return (
    <Container id="manage-subscriptions" disableGutters>
      <ApplicationHeader />

      <ApplicationPanel>
        <SubscriptionsBrowse
          searchState={searchState}
          onSearchStateChange={state => setSearchState(state)}
          searchResults={searchResults}
        />
      </ApplicationPanel>
    </Container>
  );
};

export default ManageSubscriptionsView;
